var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZegar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2911_3613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 21.337C18.5647 21.337 21.8716 18.0301 21.8716 13.9654C21.8716 9.90068 18.5647 6.59375 14.5 6.59375C10.4353 6.59375 7.12836 9.90068 7.12836 13.9654C7.12836 18.0301 10.4353 21.337 14.5 21.337ZM10.8351 13.233H13.7676V10.3005H15.2324V14.6978H10.8351V13.233Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3019 21.7675C24.3859 19.6836 25.5336 16.9128 25.5336 13.9656C25.5336 11.7806 24.9023 9.69301 23.7268 7.90996L24.1824 7.36701C24.7277 6.71722 24.9872 5.89396 24.9133 5.04891C24.8394 4.20387 24.4408 3.43822 23.791 2.89298C22.4496 1.76743 20.4426 1.94305 19.317 3.28442L18.8629 3.82556C17.7219 3.33432 16.4979 3.03887 15.2324 2.95645V1.4648H16.699V0H12.3011V1.4648H13.7676V2.95645C12.5022 3.03882 11.2782 3.33432 10.1371 3.82556L9.68305 3.28442C9.1378 2.63459 8.37215 2.23601 7.52716 2.16209C6.68148 2.08812 5.85881 2.34773 5.20902 2.89298C4.55919 3.43822 4.16062 4.20392 4.08669 5.04891C4.01277 5.89396 4.27233 6.71717 4.81758 7.36696L5.27318 7.90996C4.09778 9.69301 3.4664 11.7806 3.4664 13.9656C3.4664 16.9128 4.61412 19.6836 6.69809 21.7675C6.98138 22.0508 7.27771 22.3161 7.58512 22.5643L6.46792 24.1598L7.66778 25L8.78318 23.407C10.4895 24.4445 12.452 24.9992 14.5 24.9992C16.548 24.9992 18.5105 24.4445 20.2169 23.407L21.3322 25L22.5321 24.1598L21.4149 22.5643C21.7223 22.3161 22.0187 22.0508 22.3019 21.7675ZM14.5 5.12914C19.3724 5.12914 23.3364 9.09317 23.3364 13.9656C23.3364 18.838 19.3724 22.802 14.5 22.802C9.62758 22.802 5.66355 18.838 5.66355 13.9656C5.66355 9.09317 9.62758 5.12914 14.5 5.12914Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2911_3613"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZegar);
export default __webpack_public_path__ + "static/media/zegar.b7a3ae1ea0113f84bc9bacd4451f8452.svg";
export { ForwardRef as ReactComponent };